var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 8.6c.07.06.1.13.1.2 0 .06-.03.13-.1.2l-.74.75c-.05.05-.12.07-.21.07-.1 0-.16-.02-.21-.07l-2.67-2.63-2.67 2.63c-.05.05-.12.07-.22.07-.09 0-.16-.02-.2-.07L6.85 9c-.07-.07-.11-.14-.11-.2 0-.07.04-.14.1-.2L9.54 6 6.82 3.4c-.14-.13-.14-.26 0-.4l.77-.75c.05-.05.12-.07.21-.07.1 0 .17.02.22.07l2.67 2.6 2.67-2.6c.05-.05.12-.07.21-.07.1 0 .16.02.21.07l.77.75c.15.14.15.27 0 .4L11.85 6l2.67 2.6zM17.54.47c.3.3.46.67.46 1.12v8.73c0 .45-.16.85-.47 1.18-.32.33-.7.49-1.15.49H5.91a2.52 2.52 0 0 1-2-.99l-.04-.03L0 6 3.87.95C4.36.32 5.04 0 5.9 0h10.47c.45 0 .83.16 1.16.48zm-.66 9.93V1.52c0-.35-.17-.52-.5-.52H5.91c-.47 0-.85.19-1.13.56L1.41 6l3.37 4.44c.3.37.68.56 1.13.56h10.47c.33 0 .5-.2.5-.59z",
    fill: "#1E1E1E",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDelete);
export default __webpack_public_path__ + "static/media/btn-delete.263a4b8ec39c322900d5df0776e73579.svg";
export { ForwardRef as ReactComponent };